import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types'
import Input from '../../1_Atoms/Forms/Input/Input';
import Button from '../../1_Atoms/Button/Button';
import FormGroup from '../../2_Molecules/FormGroup/FormGroup';
import { handleRequest } from '../../../utils/httpRequest';
import { getEndpointUrl } from '../../../utils/endPoints';
import Form from '../../2_Molecules/Form/Form';
import { languageController } from '../../../controllers/language/languageController';
import { useForm } from '../../../hooks/useForm';
import FormContainer from '../../2_Molecules/FormContainer/FormContainer';
import FormConfirmation from '../../2_Molecules/FormConfirmation/FormConfirmation';
import Checkbox from '../../1_Atoms/Forms/Checkbox/Checkbox';
import parse from 'html-react-parser';
import Modal from '../../2_Molecules/Modal/Modal';

function SendBuildToDealerModal({ formExtraParams }) {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formError, setFormError] = useState(null);
  const [isModalClosed, setIsModalClosed] = useState(false);

  const { language } = formExtraParams

  const initState = {
    firstname: '',
    lastname: '',
    email: '',
    postalcode: '',
    buildname: '',
    optin: false,
  }

  const validations = {
    firstname: ['required', 'name', 'nameMaxMin'],
    lastname: ['required', 'name', 'nameMaxMin'],
    email: ['required', 'email'],
    postalcode: ['required', 'postalcode'],
    buildname: ['required'],
  }

  const { handleSubmit, handleChange, data, errors, setData } = useForm({
    initState,
    validations,
    // Send the form data if validated
    onSubmit: async () => {
      try {
        // TODO: Complete here when the BE api is ready.
        // const endPointUrl = getEndpointUrl('');
        // const res = await handleRequest('post', endPointUrl, data});
        // if (res.Success) {
        setIsSubmitted(true);
        setData(initState)
        // } else {
        //   setFormError(res.state ? res.state : res.Errors[0])
        // }
      } catch (err) {
        console.log(err)
      }
    },
  })

  const { firstname, lastname, email, postalcode, buildname, optin } = data;

  return (
    <Modal
      className="mz-modal-form mz-send-build-to-dealer-modal"
      id="mz-react-send-build-to-dealer-modal"
      isOpen={!isModalClosed && isSubmitted}
      // isOpen={true}
    >
      <FormContainer
        className="mz-send-build-to-dealer"
        isSubmitted={isSubmitted}
        heading={(
          <Fragment>
            <h3>{languageController.getCopy('sendBuildToDealer', 'heading')}</h3>
            <p>{languageController.getCopy('sendBuildToDealer', 'subHeading')}</p>
          </Fragment>
        )}
        confirmation={(
          <FormConfirmation
            heading={languageController.getCopy('sendBuildToDealer', 'confirmationHeading')}
            subHeading={languageController.getCopy('sendBuildToDealer', 'confirmationSubHeading')}
            buttonLabel={languageController.getCopy('sendBuildToDealer', 'confirmationSubmit')}
            onClick={() => setIsModalClosed(true)}
          />
        )}
        disclaimer={(
          <Checkbox
            name="optin"
            checked={optin}
            onChange={(e) => setData({ ...data, optin: !optin })}
            label={parse(languageController.getCopy('global', 'subscribeLegal'))}
          />
        )}
      >
        <Form
          onSubmit={handleSubmit}
          isDark={false}
          noValidate={true}
          errorMessage={formError}
        >
          <FormGroup md={2}>
            <Input
              type="text"
              name="firstname"
              label={languageController.getFormCopy('label', 'firstname')}
              value={firstname}
              isRequired={true}
              errorMessage={errors.firstname}
              onChange={handleChange}
              maxLength={50}
            />
            <Input
              type="text"
              name="lastname"
              label={languageController.getFormCopy('label', 'lastname')}
              value={lastname}
              isRequired={true}
              errorMessage={errors.lastname}
              onChange={handleChange}
              maxLength={50}
            />
          </FormGroup>
          <Input
            type="email"
            name="email"
            label={languageController.getFormCopy('label', 'email')}
            value={email}
            isRequired={true}
            errorMessage={errors.email}
            onChange={handleChange}
            maxLength={320}
          />
          <FormGroup md={2}>
            <Input
              type="text"
              name="postalcode"
              label={languageController.getFormCopy('label', 'postalcode')}
              value={postalcode}
              isRequired={true}
              errorMessage={errors.postalcode}
              onChange={handleChange}
              maxLength={7}
            />
          </FormGroup>
          <Input
            type="text"
            name="buildname"
            label={languageController.getFormCopy('label', 'buildName')}
            value={buildname}
            isRequired={true}
            errorMessage={errors.buildname}
            onChange={handleChange}
            maxLength={100}
          />
          <Button
            type="submit"
            className="mz-btn--primary mz-btn--red"
            label={languageController.getCopy('sendBuildToDealer', 'submit')}
          />
        </Form>
      </FormContainer>
    </Modal>
  )
}

SendBuildToDealerModal.propTypes = {
  formExtraParams: PropTypes.object
}

export default SendBuildToDealerModal